import React from "react";
import { Star } from "react-feather";
import { TOTAL_REVIEW_COUNT, REVIEW_AVG } from "../consts";

function HeroRatingStars({ theme, centerAll, classes = "", centerMobile }) {
  return (
    <div className={`${centerAll && "md:text-center"} font-display text-left ${theme == "light" ? "text-white" : "text-neutral-800"}`}>
      <div className={` font-semibold ${classes}`}>
        <div className={`flex items-center mb-2 ${centerMobile && 'justify-center md:justify-start'} ${centerAll ? "justify-center" : " justify-start"}`}>
          {new Array(5).fill("").map((item) => (
            <Star fill={"#f28d24"} stroke={"0"} />
          ))}
        </div>
        {/* Plain text, no schema.org markup: as a Product with an
            AggregateRating it was the business rating itself, which Google's
            review snippet rules do not allow (self-serving reviews). */}
        <span className="rating-desc">
          <span>Roach Home Improvement</span>{" "}
          <span>
            rated <span>{REVIEW_AVG}</span>/5 <br />
            based on <span>{TOTAL_REVIEW_COUNT}</span> reviews.{" "}
          </span>
        </span>
      </div>
    </div>
  );
}

export default HeroRatingStars;
